import lodashUtil from 'lodash';
import { gradePickerUtil } from '../../../gradePicker'
import { updatingRulesUtil } from '../../updatingRulesUtil'

export const getFixedTeachersAndTAsForSubject = (teachersAndTAsObj) => {
  let fixedTeacherArray = teachersAndTAsObj.teachers.fixed;
  let preferredTeacherArray = teachersAndTAsObj.teachers.preferred;
  let fixedTAsArray = teachersAndTAsObj.TAs.fixed;
  let preferredTAsArray = teachersAndTAsObj.TAs.preferred;

  let fixedTeacherString = extractingStringFromArray(fixedTeacherArray);
  let preferredTeacherString = extractingStringFromArray(preferredTeacherArray);
  let fixedTAsString = extractingStringFromArray(fixedTAsArray);
  let preferredTAsString = extractingStringFromArray(preferredTAsArray);

  let teachersForSubjectString = `${fixedTeacherString} - ${preferredTeacherString}`
  let tAsForSubjectString = `${fixedTAsString} - ${preferredTAsString}`

  let fixedTeachersAndTAsForSubjectString = {
    teachersForSubjectString: teachersForSubjectString,
    tAsForSubjectString: tAsForSubjectString,
  }
  return fixedTeachersAndTAsForSubjectString;
}

export const extractingStringFromArray = (teacherOrTAsArray) => {
  let teacherIdArray = []
  for (let i = 0; i < teacherOrTAsArray.length; i++) {
    let obj = teacherOrTAsArray[i]
    teacherIdArray.push(obj.teacherId);
  }
  let teacehrIdString = teacherIdArray.toString();
  return teacehrIdString
}


// When Grade details are changed delete the related rules

export const deleteRulesIfGradedetailsChanged = (scheduleConstraints, constraintsArray, electiveObj) => {
  for (let i = 0; i < scheduleConstraints.length; i++) {
    let scheduleObj = scheduleConstraints[i]

    for (let j = 0; j < constraintsArray.length; j++) {
      let ruleName = constraintsArray[j]

      let updateRule = scheduleObj[ruleName]
      if (updateRule.length > 0) {
        for (let k = 0; k < updateRule.length; k++) {

          if (electiveObj.isSubject !== undefined && electiveObj.isSubject === true) {
            if (ruleName === "numberOfTeachersAndTAsForElectives") {
              let tecaherAndTA = updateRule[k].teachersAndTAs
              tecaherAndTA = deleteRulesIfGradedetailsChangedForElectives(tecaherAndTA, electiveObj, scheduleConstraints[i])
              if (tecaherAndTA.length === 0) {
                if (scheduleConstraints[i].status !== 'Completed') {
                  updateRule.splice(k, 1)
                  k -= 1
                  scheduleConstraints[i].isSCheduleUpdated = true
                } else {
                  updateRule[k].isDirty = true;
                  scheduleConstraints[i].isSCheduleUpdated = true
                }
              } else {
                for (let taIndex = 0; taIndex < tecaherAndTA.length; taIndex++) {
                  if (tecaherAndTA[taIndex].isDirty) {
                    updateRule[k].isDirty = true;
                    scheduleConstraints[i].isSCheduleUpdated = true
                  }
                }
              }

            }
            else if (ruleName === "fixedTeachersAndTAsForElectives") {
              let tecaherAndTA = updateRule[k].teachersAndTAs
              tecaherAndTA = deleteRulesIfGradedetailsChangedForElectives(tecaherAndTA, electiveObj, scheduleConstraints[i])
              if (tecaherAndTA.length === 0) {
                if (scheduleConstraints[i].status !== 'Completed') {
                  updateRule.splice(k, 1)
                  k -= 1
                  scheduleConstraints[i].isSCheduleUpdated = true
                } else {
                  updateRule[k].isDirty = true;
                  scheduleConstraints[i].isSCheduleUpdated = true
                }
              } else {
                for (let tIndex = 0; tIndex < tecaherAndTA.length; tIndex++) {
                  if (tecaherAndTA[tIndex].isDirty) {
                    updateRule[k].isDirty = true;
                    scheduleConstraints[i].isSCheduleUpdated = true
                  }
                }
              }

            } else if (ruleName === "sharedRoomsForElectives") {
              let subjects = updateRule[k].subjects
              subjects = deleteRulesIfGradedetailsChangedForElectives(subjects, electiveObj, scheduleConstraints[i])
              if (subjects.length === 0 || subjects.length === 1) {
                if (scheduleConstraints[i].status !== 'Completed') {
                  updateRule.splice(k, 1)
                  k -= 1
                  scheduleConstraints[i].isSCheduleUpdated = true
                } else {
                  updateRule[k].isDirty = true;
                  scheduleConstraints[i].isSCheduleUpdated = true
                }
              } else {
                for (let sIndex = 0; sIndex < subjects.length; sIndex++) {
                  if (subjects[sIndex].isDirty) {
                    updateRule[k].isDirty = true;
                    scheduleConstraints[i].isSCheduleUpdated = true
                  }
                }
              }

            }
          }
          let subObjIndexs = [];
          if (electiveObj.isSubject !== undefined && electiveObj.isSubject === true) {
            subObjIndexs = getAllIndexes(updateRule, 'subjectId', electiveObj._id);
          } else {
            subObjIndexs = getAllIndexes(updateRule, 'electiveId', electiveObj._id);
          }
          if (subObjIndexs.length > 0) {
            for (let soIndex = 0; soIndex < subObjIndexs.length; soIndex++) {
              if (scheduleConstraints[i].status !== 'Completed') {
                updateRule.splice(subObjIndexs[soIndex], 1);
              } else {
                updateRule[subObjIndexs[soIndex]].isDirty = true;
                scheduleConstraints[i].isSCheduleUpdated = true
              }
            }
          }
        }
      }
    }
    if (scheduleConstraints[i].isSCheduleUpdated !== undefined && scheduleConstraints[i].isSCheduleUpdated === true) {
      scheduleConstraints[i].version = scheduleConstraints[i].version + 1
    }
  }
  return scheduleConstraints
}

export const deleteRulesIfGradedetailsChangedForElectives = (tecaherAndTA, electiveObj, scheduleConstraint) => {
  let subObj = lodashUtil.findIndex(tecaherAndTA, ["subjectName", electiveObj.name]);
  if (subObj !== -1) {
    if (scheduleConstraint.status !== 'Completed') {
      tecaherAndTA.splice(subObj, 1);
    } else {
      tecaherAndTA[subObj].isDirty = true;
      scheduleConstraint.isSCheduleUpdated = true;
    }
  }
  return tecaherAndTA
}

//Check if garde Details are changed  and are added for that elective/subject / assigned subject for that.
export const checkIfGradeDetailsAreChanged = (constraintsArray, gradeDetails, showGradeDetailChangeConfirmDialog, elective, scheduleConstraints, props) => {
  let findElectiveInRule = false;
  let oldGradeDetail = gradePickerUtil.convertingGradeDetailsToLowestFormat(elective.gradeDetails, props);
  let newGradeDetail = gradePickerUtil.convertingGradeDetailsToLowestFormat(gradeDetails, props);
  if (oldGradeDetail.length === newGradeDetail.length) {
    let checkIfGradeDetailIsChanged = lodashUtil.difference(oldGradeDetail, newGradeDetail);
    if (checkIfGradeDetailIsChanged.length !== 0) {
      findElectiveInRule = true
    }
  } else {
    findElectiveInRule = true
  }
  if (scheduleConstraints.length != 0) {
    for (let i = 0; i < scheduleConstraints.length; i++) {
      let scheduleObj = scheduleConstraints[i]

      for (let j = 0; j < constraintsArray.length; j++) {
        let ruleName = constraintsArray[j]
        let updateRule = scheduleObj[ruleName]

        if (findElectiveInRule === true) {
          if (updateRule.length > 0) {
            for (let i = 0; i < updateRule.length; i++) {
              let subObjIndex = lodashUtil.find(updateRule, ["electiveId", elective._id]);
              if (subObjIndex != undefined) {
                showGradeDetailChangeConfirmDialog = true
                break;
              }
            }
          }
        }
      }
    }
  }
  return showGradeDetailChangeConfirmDialog
}
export const getSharedRoomsForSubjectString = (rooms) => {
  let roomArray = [];
  for (let i = 0; i < rooms.length; i++) {
    let roomName = rooms[i].name
    roomArray.push(roomName);
  }
  let sharedRoomsForSubjectString = roomArray.toString();
  return sharedRoomsForSubjectString;
}

export const deleteDirtyObjectsFromRules = (scheduleObj) => {
  let constraintsArray = updatingRulesUtil.constraintsArray
  for (let j = 0; j < constraintsArray.length; j++) {
    let ruleName = constraintsArray[j]
    let ruleArray = scheduleObj[ruleName]
    if (ruleArray.length > 0) {
      for (let k = 0; k < ruleArray.length; k++) {
        if (ruleArray[k].isDirty === true) {
          ruleArray.splice(k, 1)
          k -= 1;
        }
      }
    }
  }
  return scheduleObj;
}


function getAllIndexes(arr, key, val) {
  let indexes = [], i;
  for (i = 0; i < arr.length; i++) {
    if (arr[i][key] === val) {
      indexes.push(i);
    }
  }
  return indexes;
}